import * as tslib_1 from "tslib";
import { jsonMapMember, jsonMember, jsonObject } from "typedjson";
import { DxBaseControlOptions } from "./dx-base-control-options";
let DxComboboxControlOptions = class DxComboboxControlOptions extends DxBaseControlOptions {
    constructor() {
        /**
         * Возможные опции для комбика
         *  @controlId: string - ID контрола
         *  @label: string - подпись
         *  @hint: string - всплывающая подсказка
         *  @isDisabled: boolean - поле активно/не активно
         *  @isHidden: boolean - поле спрятано/отображается
         *
         *  @labelField: string - имя поля в массиве передаваемых элементов, корое будет использоваться для отображения данных в комбике
         *  @valueField: string - имя поля в массиве передаваемых элементов, корое будет использоваться в качестве id-шников
         *  @isSearchable: boolean - возможность поиска по элементам комбика
         *  @isMultiselect: boolean - возможность множественного выбора
         *  @hasLabels: boolean - мультиселект отображать метками или нет (только если isMultiselect: true)
         *
         * */
        super(...arguments);
        /** говорит о том что комбик работает c серверной моделью данных и требудется предоставление реализации датасорса */
        this._useServerSideModel = false;
    }
    get labelField() {
        return this._labelField;
    }
    set labelField(value) {
        this._labelField = value;
    }
    get valueField() {
        return this._valueField;
    }
    set valueField(value) {
        this._valueField = value;
    }
    get isSearchable() {
        return this._isSearchable;
    }
    set isSearchable(value) {
        this._isSearchable = value;
    }
    get isMultiselect() {
        return this._isMultiselect;
    }
    set isMultiselect(value) {
        this._isMultiselect = value;
    }
    get hasLabels() {
        return this._hasLabels;
    }
    set hasLabels(value) {
        this._hasLabels = value;
    }
    get useServerSideModel() {
        return this._useServerSideModel;
    }
    set useServerSideModel(value) {
        this._useServerSideModel = value;
    }
    get datasourceIdent() {
        return this._datasourceIdent;
    }
    set datasourceIdent(value) {
        this._datasourceIdent = value;
    }
    get filter() {
        return this._filter;
    }
    set filter(value) {
        this._filter = value;
    }
    get sorts() {
        return this._sorts;
    }
    set sorts(value) {
        this._sorts = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "labelField", constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], DxComboboxControlOptions.prototype, "_labelField", void 0);
tslib_1.__decorate([
    jsonMember({ name: "valueField", constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], DxComboboxControlOptions.prototype, "_valueField", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isSearchable", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxComboboxControlOptions.prototype, "_isSearchable", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isMultiselect", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxComboboxControlOptions.prototype, "_isMultiselect", void 0);
tslib_1.__decorate([
    jsonMember({ name: "hasLabels", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxComboboxControlOptions.prototype, "_hasLabels", void 0);
tslib_1.__decorate([
    jsonMember({ name: "useServerSideModel", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxComboboxControlOptions.prototype, "_useServerSideModel", void 0);
tslib_1.__decorate([
    jsonMember({ name: "datasourceIdent", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxComboboxControlOptions.prototype, "_datasourceIdent", void 0);
tslib_1.__decorate([
    jsonMapMember(String, Object, { name: 'filter', emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Map)
], DxComboboxControlOptions.prototype, "_filter", void 0);
tslib_1.__decorate([
    jsonMapMember(String, String, { name: 'sorts', emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Map)
], DxComboboxControlOptions.prototype, "_sorts", void 0);
DxComboboxControlOptions = tslib_1.__decorate([
    jsonObject
], DxComboboxControlOptions);
export { DxComboboxControlOptions };
